import React, { useState } from 'react';
import moment from 'moment';
import Header from './components/Header';
import MonthView from './components/MonthView';

export interface CalendarProps {
  today?: Date;
  achievedDates?: { [date: string]: string };
  startDate?: Date;
  endDate?: Date;
  achievedDatesNumber?: any;
  aktivoStepStats?: any;
}

const YEAR_MONTH_FORMAT = 'YYYY-MM';

const Calendar: React.FC<CalendarProps> = ({
  today = new Date(),
  achievedDates = {},
  startDate,
  endDate,
  achievedDatesNumber,
  aktivoStepStats,
}) => {
  const [viewDate, setViewDate] = useState<Date>(today);
  const [achieveDays, setAchieveDays] = useState<any>(achievedDatesNumber);
  const headerProps = {
    viewDate,
    achievedDatesNumber: achieveDays,
    onChange: (newViewDate: Date) => {
      const newViewDateFormat = moment(newViewDate).format(YEAR_MONTH_FORMAT);
      const achieveDays = Object.keys(achievedDates).filter(
        (date) =>
          achievedDates[date] === 'Y' &&
          moment(date).format(YEAR_MONTH_FORMAT) === newViewDateFormat,
      ).length;
      setViewDate(newViewDate);
      setAchieveDays(achieveDays);
    },
    startDate,
    endDate,
  };
  const monthViewProps = {
    viewDate,
    achievedDates,
    startDate,
    endDate,
    aktivoStepStats,
  };

  return (
    <div>
      <Header {...headerProps} />
      <MonthView {...monthViewProps} />
    </div>
  );
};

export default Calendar;
